<template>
  <div class="group-detail">
    <h1 class="common__main-title"> Mail Template {{ routeStateName }} </h1>
    <div class="common__sub-title">
      <span>{{ routeStateName }}</span>
    </div>
    <div class="content-wrapper">
      <ValidationObserver ref="observer">
        <InputForm ref="inputForm" :initContents="initContents" />
      </ValidationObserver>

      <div class="d-flex justify-content-between">
        <b-button pill variant="secondary" :to="{ name: 'MailTemplates' }">
          Back
        </b-button>
        <b-button v-if="$route.name === 'MailTemplateEdit'" pill variant="danger" @click="remove">
          Delete
        </b-button>
        <b-button pill variant="primary" @click="confirm">
          Confirm
        </b-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import InputForm from '@/components/parts/mails/templates/InputForm.vue'
import { ValidationObserver } from 'vee-validate'
import { MailTemplate } from '@/store/mails/templates/types'

export default Vue.extend({
  components: {
    InputForm,
    ValidationObserver,
  },

  data(): {
    initContents: MailTemplate|null,
    } {
    return {
      initContents: null,
    }
  },

  created(): void {
    if (this.$route.params.editingMailTemplate) {
      // もし編集情報があるならそれを表示
      this.initContents = JSON.parse(this.$route.params.editingMailTemplate)
    } else if (this.$route.params.mailTemplateId) {
      // もしURLにIDがある場合は編集 or コピー
      const id = this.$route.params.mailTemplateId
      this.$store.dispatch('getMailTemplate', id)
        .then(() => {
          this.initContents = this.$store.getters.findMailTemplateById(id)
        })
    }
  },

  computed: {
    routeStateName(): string|Error {
      switch (this.$route.name) {
        case 'MailTemplateAdd':
          return 'Register'
        case 'MailTemplateEdit':
          return 'Edit'
        case 'MailTemplateCopy':
          return 'Copy'
        default:
          throw Error(`未知のルート名: ${this.$route.name}`)
      }
    },
  },

  methods: {
    /**
     * 確認画面に遷移（バリデーションに問題なければ）
     */
    confirm() {
      (this.$refs.observer as any).validate()
        .then((result: boolean) => {
          if (result !== true) {
            return
          }

          let routeName = null
          switch (this.$route.name) {
            case 'MailTemplateAdd':
              routeName = 'MailTemplateConfirm'
              break
            case 'MailTemplateEdit':
              routeName = 'MailTemplateEditConfirm'
              break
            case 'MailTemplateCopy':
              routeName = 'MailTemplateCopyConfirm'
              break
            default:
              throw Error(`未知のルート名: ${this.$route.name}`)
          }

          const { contents } = (this.$refs.inputForm as InputForm)

          this.$router.push({
            name: routeName,
            params: _.pickBy({
              mailTemplateId: this.$route.params.mailTemplateId,
              editingMailTemplate: JSON.stringify(contents),
            }),
          })
        })
    },
    /**
     * 削除
     */
    async remove() {
      const result = await this.$bvModal.msgBoxConfirm('Are you sure to delete this mail template?')
      if (result !== true) {
        return
      }

      await this.$store.dispatch('deleteMailTemplate', this.$route.params.mailTemplateId)
      await this.$bvModal.msgBoxOk('Success !')
      this.$router.push({ name: 'MailTemplates' })
    },
  },
})
</script>

<style scoped>
.content-wrapper {
  background: #D8D8D8;
  padding: 20px 50px;
}

.button-container {
  display: flex;
  justify-content: space-between;
}
</style>
